import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

export const skillGapAnalysisService = {

  addToLearningPlan: async () => {
    try {
      const response = await api1.put(API_ENDPOINTS.ADD_TO_LEARNING_PLAN);
      return response.data;
    } catch (error) {
      console.error("Error adding to learning plan:", error);
      throw error;
    }
  },

  getLatestLearningPlanAnalysis: async () => {
    try {
      const response = await api1.get(API_ENDPOINTS.GET_LATEST_LEARNING_PLAN_ANALYSIS);
      return response.data;
    } catch (error) {
      console.error("Error getting latest learning plan analysis:", error);
      throw error;
    }
  }
};
